var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightSound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 64,
    viewBox: "0 0 55 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA2\xD0\xB8\xD0\xBF=\xD0\x94\xD0\xB8\xD0\xBD\xD0\xB0\xD0\xBC\xD0\xB8\xD0\xBA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.9309 8.17C43.2736 7.88544 42.4991 7.96086 41.9324 8.3757L23.5573 21.7157H14.7778C12.6962 21.7157 11 23.2551 11 25.1441V38.8579C11 40.7504 12.6962 42.2863 14.7778 42.2863H23.5573L41.9287 55.6263C42.2724 55.8731 42.6918 56 43.1111 56C43.3907 56 43.6702 55.9417 43.9309 55.8286C44.5844 55.544 45 54.944 45 54.2858V9.71622C45 9.05796 44.5844 8.45798 43.9309 8.17Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSound);
export default __webpack_public_path__ + "static/media/light_sound.b4669c0e5b80ae7ecd294527cb9a4a55.svg";
export { ForwardRef as ReactComponent };